import type { PromoCarouselTracking } from "@membership/ui.components";
import { track, trackClick } from "tracking";

const onChevronClicked: PromoCarouselTracking["onChevronClicked"] = ({
  location_type,
  module_content,
  module_content_details,
  module_content_details2
}) => {
  trackClick({
    event: "Page Element Clicked",
    properties: {
      location_type,
      module_content,
      module_content_details,
      ...(module_content_details2 && { module_content_details2 })
    }
  });
};

const onMessageClicked: PromoCarouselTracking["onMessageClicked"] = ({
  location_type,
  module_content,
  module_content_details,
  module_content_url
}) => {
  trackClick({
    event: "Page Element Clicked",
    properties: {
      location_type,
      module_content,
      module_content_details,
      module_content_url
    }
  });
};

const onMessageViewed: PromoCarouselTracking["onMessageViewed"] = ({
  location_type,
  module_content,
  module_content_details,
  module_content_details2
}) => {
  track({
    event: "Page Element Viewed",
    properties: {
      location_type,
      module_content,
      module_content_details,
      ...(module_content_details2 && { module_content_details2 })
    }
  });
};

const onBannerClicked: PromoCarouselTracking["onBannerClicked"] = ({
  location_type,
  module_content
}) => {
  trackClick({
    event: "Page Element Clicked",
    properties: {
      location_type,
      module_content
    }
  });
};

export const useTracking = () => {
  return {
    onBannerClicked,
    onMessageViewed,
    onMessageClicked,
    onChevronClicked
  };
};
